import _ from 'lodash';
import AppConstatnt from '../../../../config/app.constants';

class ItemHoldsController {
  /*@ngInject*/

  constructor(Auth, $state, User, UserService, SetupService, DateUtil, RouteService, $translate, LocationService,
              DataCounter, ScanService, $location, $q, Modal, ShipmentService, BranchService, HoldService, $scope,
              UsersService, Sound, RouteStopService, Navigation, BulkCashService, $rootScope, CommonLayoutService) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.ScanService = ScanService;
    this.DataCounter = DataCounter
    this.$q = $q;
    this.$scope = $scope;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.HoldService = HoldService;
    this.BulkCashService = BulkCashService;
    this.UsersService = UsersService;
    this.RouteStopService = RouteStopService;
    this.Sound = Sound;
    this.Navigation = Navigation;
    this.$rootScope = $rootScope;
    this.CommonLayoutService = CommonLayoutService;

    this.model = {
      loading: false,
      lastChecked: null,
      search: null,
      branch: User.getUser().branchId,
      status: '',
      dateRange: {
        startDate: null,
        endDate: null
      },
      // includeReleased: false,

      dateRangPickerOptions: {
        autoApply: true,
        maxDate: moment(),
        eventHandlers: {
          'apply.daterangepicker': () => {
            this.loadData();
          }
        },
        ranges: {}
      },
      defaultRanges: {
        'Today': [
          moment().startOf('day'),
          moment()
        ]
      },
      extraRanges: {
        'Current Week': [
          moment().startOf('week'),
          moment()
        ],
        'Current Month': [
          moment().startOf('month'),
          moment()
        ]
      },
      hasUnverifiedShipments: false,
      showVerifiedDate: false
    };

    this.fromLocations = [];
    this.toLocations = [];
    this.supervisors = [];
    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: AppConstatnt.defaultPageLimit,
      maxPages: 10
    };

    this.statusList = [
      {
        lable: 'All',
        value: ''
      },
      {
        lable: 'Unverified',
        value: 'notSameVaultDate'
      },
      {
        lable: 'Verified',
        value: 'sameVaultDate'
      }
    ]

    this.shipments = [];
    this.branches = [];
    this.currentVaultDate = "";
    this.sortColumn = "verifiedOn";
    this.reverseSort = true;
    this.branchTimeZone = "";
    this.reportPrefix = 'Item_Hold';
    this.isExporting = false;
    this.shipmentData = '';
    this.branchVaultDate = '';
    this.loggedInUser = this.User.getUser().id;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/item-holds');
    this.toggleSwitchUI = {
      size: 'small',
      onColor: 'success',
      offColor: 'danger'
    };
    this.showMapView = false;
    this.map = null;
  }

  updateLastChecked() {
    this.model.lastChecked = moment(this.currentVaultDate).format('YYYY-MM-DD');
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach((permission) => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    this.loadData()
  }

  search() {
    this.pagination.page = 1;
    this.loadData()
  }

  generateSearchObj() {
    // const searchObj = {
    //   queryJSON: {
    //     rules: [
    //       {
    //         field: 'status',
    //         condition: '=',
    //         data: 'ON_HOLD'
    //       },
    //     ],
    //     operator: 'AND'
    //   }
    // };

    // if (this.model.search) {
    //   searchObj.queryJSON.rules.push({
    //     group: {
    //       rules: [
    //         {
    //           field: 'trackingId',
    //           condition: 'like',
    //           data: `%${this.model.search}%`
    //         },
    //         {
    //           field: 'toLocationId',
    //           condition: 'like',
    //           data: `%${this.model.search}%`
    //         }
    //       ],
    //       operator: 'OR'
    //     }
    //   });
    // }

    // if (this.User.getUser().branchId) {
    //   searchObj.queryJSON.rules.push({
    //     field: 'branchId',
    //     condition: '=',
    //     data: this.User.getUser().branchId
    //   });
    // }

    // // for verified shipment
    // if (this.model.status === 'sameVaultDate') {
    //   searchObj.queryJSON.rules.push({
    //     field: 'verifiedOn',
    //     condition: '=',
    //     data: this.currentVaultDate
    //   })
    // }

    // // for unverified shipment
    // if (this.model.status === 'notSameVaultDate') {
    //   searchObj.queryJSON.rules.push({
    //     group: {
    //       rules: [
    //         {
    //           field: 'verifiedOn',
    //           condition: '=',
    //           data: null
    //         },
    //         {
    //           field: 'verifiedOn',
    //           condition: '!=',
    //           data: this.currentVaultDate
    //         }
    //       ],
    //       operator: 'OR'
    //     }
    //   })
    // }

    // if (this.model.fromLocation && this.model.fromLocation.Key) {
    //   searchObj.queryJSON.rules.push({
    //     field: 'fromLocationId',
    //     condition: '=',
    //     data: this.model.fromLocation.Value
    //   });
    // }

    // if (this.model.toLocation && this.model.toLocation.Key) {
    //   searchObj.queryJSON.rules.push({
    //     field: 'toLocationId',
    //     condition: '=',
    //     data: this.model.toLocation.Value
    //   });
    // }

    // if (this.model.supId && this.model.supId.Key) {
    //   searchObj.queryJSON.rules.push({
    //     field: 'supvHoldId',
    //     condition: '=',
    //     data: this.model.supId.Value
    //   });
    // }

    // return searchObj.queryJSON.rules.length ? searchObj : null;

    let searchObj = {
      trackingId: this.model.search ? `%${this.model.search}%` : null,
      toLocationId: this.model.toLocation && this.model.toLocation.Key ? this.model.toLocation.Value : null,
      fromLocationId: this.model.fromLocation && this.model.fromLocation.Key ? this.model.fromLocation.Value : null,
      supId: this.model.supId && this.model.supId.Key ? this.model.supId.Value : null,
      isVerified: this.model.status === 'sameVaultDate' ? true : false,
      verifiedOn: (this.model.status === 'sameVaultDate' || this.model.status === 'notSameVaultDate') ? this.currentVaultDate : null,
      branchId: this.User.getUser().branchId,
      sortOrder: this.reverseSort ? 'DESC' : 'ASC',
      sortColumn: this.sortColumn
    }
    return searchObj;
  }

  loadData() {
    const searchObj = this.generateSearchObj();
    this.model.loading = true;
    this.moment = moment;
    this.model.hasUnverifiedShipments = false;
    // this.model.showVerifiedDate = false;
    this.verifiedOn = "";
    this.updateLastChecked();

    return this.HoldService.holdItems(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
      .then((data) => {
        this.pagination.total = data.total;

        this.pagination.loading = false;
        this.shipments = data.results;

        if (this.model.status !== 'sameVaultDate' && data.pendingToVerifyShipments > 0) {
          this.model.hasUnverifiedShipments = true;
        }

        this.shipments.forEach((shipment) => {
          this.verifiedOn = moment.utc(shipment.verifiedOn).format('YYYY-MM-DD');
          shipment.onHold = shipment.status === 'ON_HOLD';

          if (shipment.onHold) {

            // if (!shipment.verifiedOn || this.verifiedOn != this.currentVaultDate) {
            //   this.model.hasUnverifiedShipments = true;
            // }

            // if (this.verifiedOn == this.currentVaultDate) {
            //   this.model.showVerifiedDate = true;
            // }

            shipment.status = 'HOLD';
          }
          else {
            shipment.status = 'RELEASES';
          }
        });
      })
      // .then(() => {
      //   const promises = this.shipments.map(({ trackingId }) => new Promise(res => {
      //     this.ShipmentService.get(trackingId)
      //       .then(res)
      //       .catch(e => res(null))
      //   }));

      //   return this.$q.all(promises)
      //     .then((shipments) => {
      //       shipments.forEach((shipment, index) => {
      //         if (shipment == null) return;
      //         if (shipment.tankerId == null) {
      //           shipment.tankerId = this.branches.tankerId;
      //           this.shipments[index] = _.merge(this.shipments[index], shipment);
      //         } else {
      //           this.shipments[index] = _.merge(this.shipments[index], shipment);
      //         }
      //       });
      //     })
      //     .catch((err) => {
      //       this.error = err.message;
      //     });
      // })
      .catch((err) => {
        this.error = err.message
      })
      .finally(() => {
        this.model.loading = false
        this.validateMapView();
        if (this.showMapView && this.isValidMapView) {
          setTimeout(() => this.initHoldMap(), 200);
        }
      });
  }

  $onInit() {
    this.loadPermission();
    this.model.status = this.statusList[0].value;
    this.model.dateRangPickerOptions.ranges = Object.assign(this.model.defaultRanges);
    this.shipmentData = this.DataCounter.getData();
    this.$q.all([
      this.SetupService.get(this.User.getUser().branchId),
      this.loadToLocation(null, 0, AppConstatnt.defaultPageLimit),
      this.loadFromLocation(null, 0, AppConstatnt.defaultPageLimit),
      this.loadSupervisors(null, 0, AppConstatnt.defaultPageLimit),
      this.getSoftDeleteShipmentPermission()
    ])
      .then((data) => {
        this.currentVaultDate = this.DateUtil.getUTCDate(data[0].currentVaultDate); // branch vaultDate converted to UTC format
        this.branchTimeZone = data[0].timezone;
        this.branchVaultDate = data[0].currentVaultDate; // branch vaultDate without conversion
        this.setupInfo = data[0];
        this.convertToPickup = data[0].convertToPickup;
      })
      .then(() => {
        if (this.shipmentData && this.shipmentData.isRedirected) this.filterRecords();
        else this.loadData();
      })
      .catch((err) => {
        console.log(err);
      });

    this.model.dateRange
  }

  loadFromLocation(searchKey, offset) {
    let searchObj = {
      // holdFlag: 1,
      branchId: this.User.getUser().branchId,
      searchVal: searchKey || ''
    }
    this.ShipmentService.getShipmentFromLocations(searchObj, offset, AppConstatnt.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.totalFromLocation = data.total;
          this.fromLocations = this.mappingLocationData(data.results);
        }
        else {
          const fromLocations = this.mappingLocationData(data.results);
          this.fromLocations = this.fromLocations.concat(fromLocations);
        }
      })
  }

  loadToLocation(searchKey, offset) {
    let searchObj = {
      holdFlag: 1,
      branchId: this.User.getUser().branchId,
      searchVal: searchKey || ''
    }
    this.ShipmentService.getShipmentToLocations(searchObj, offset, AppConstatnt.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.totalToLocation = data.total;
          this.toLocations = this.mappingLocationData(data.results);
        }
        else {
          const toLocations = this.mappingLocationData(data.results);
          this.toLocations = this.toLocations.concat(toLocations);
        }
      })

  }

  mappingLocationData(location) {
    return location.map((loc) => {
      return {
        Key: loc.id + " | " + loc.name,
        Value: loc.id
      }
    });
  }

  loadSupervisors(searchKey, offset) {
    searchKey = searchKey || '';
    let searchObj = {
      queryJSON: {
        rules: [
          {
            field: "supervisor",
            condition: "=",
            data: true
          },
          {
            field: "branchId",
            condition: "=",
            data: this.model.branch
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'firstName',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'lastName',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: "AND"
      }
    }

    this.UsersService.all(searchObj, offset, AppConstatnt.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.totalSupervisor = data.total;
          this.supervisors = this.mappingUserData(data.results);
        }
        else {
          const supervisors = this.mappingUserData(data.results);
          this.supervisors = this.supervisors.concat(supervisors);
        }
      })
  }

  mappingUserData(users) {
    return users.map((user) => {
      return {
        Key: `${user.id} | ${user.firstName} ${user.lastName}`,
        Value: user.id
      };
    });
  }
  // show All log of itemHold data 
  showAllLog(shipment) {
    this.Modal.itemHoldLogDetails(shipment, ({ modal }) => {
    })
  }

  // Release item from HOLD
  releaseItem(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.holdReleases(shipment, !userInfo.supervisor, ({ supervisorId, comment, shipmentAssignedTo, selectedDate, routeInfo, modal }) => {
          var hDate = moment(selectedDate).format('YYYY-MM-DD');
          this.ShipmentService.holdRelease(shipment.trackingId, shipment.routeId, shipmentAssignedTo, hDate, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId)
            .then((data) => {
              modal.close();
              const totals = this.DataCounter.getCounterForItemHold();
              this.DataCounter.setCounterForItemHold(totals - 1);
              this.Sound.playSuccessBeep("#success_beep");
            })
            .then(() => {
              if (routeInfo.routeTransfered) {
                this.updateRouteDetail(shipmentAssignedTo, selectedDate);
              }
              // if (routeInfo.autoOptimize) {
              //   this.autoOptimizeRouteStop(shipmentAssignedTo, selectedDate);
              // }
            })
            .then(() => {
              this.loadData();
              this.isLoading = false;
            })
            .catch((err) => {
              modal.close();
              this.isLoading = false;
              this.Sound.PlayErrorBeep("#scanner_beep");
              if (err && err.data && err.data.message) {
                return this.Modal.errorModal("error." + err.data.message);
              }
            })
        }, ({ modal }) => {
          this.isLoading = false;
          if (modal) modal.close();
        });
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
  }

  autoOptimizeRouteStop(routeId, routeDate) {
    var formattedDate = moment.utc(routeDate).format('YYYY-MM-DD');
    this.RouteStopService.autoOptimizeRouteStops(formattedDate, routeId)
      .then((data) => { })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal(err.data.message)
        }
      })
  }

  updateRouteDetail(route, date) {
    var formattedDate = moment.utc(date).format('YYYY-MM-DD');
    const defer = this.$q.defer();
    this.HoldService.updateRouteDetail(route)
      .then((data) => {
        defer.resolve();
      })
      .catch((err) => {
        console.log(err);
        defer.reject();
      })
    defer.promise
      .then(() => {
        return this.RouteService.releaseRoute(route, formattedDate);
      })
  }

  // Cancel Delivery & Return Item from HOLD
  returnItem(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.Modal.returnItems(shipment, ({ supervisorId, comment, returnItemTo, selectedDate, modal }) => {
      var hDate = moment.utc(selectedDate).format('YYYY-MM-DD hh:mm:ss')
      this.ShipmentService.shipmentReturn(shipment.tankerId, shipment.trackingId, shipment.routeId, returnItemTo, hDate, supervisorId, comment, shipment.branchId)
        .then((data) => {
          modal.close()
          const totals = this.DataCounter.getCounterForItemHold();
          this.DataCounter.setCounterForItemHold(totals - 1);
        })
        .then(() => {
          this.loadData();
          this.isLoading = false;
        })
        .catch((err) => {
          modal.close();
          this.isLoading = false;
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal("error." + err.data.message);
          }
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.isLoading = false;
    });
  }

  // verify hold shipment, update tanker for shipemnt 
  validateSupervisorScan() {
    if (this.isLoading) return;
    this.isLoading = true;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        if (userInfo && userInfo.supervisor) {
          this.$rootScope.supervisorIds = {
            id: userInfo.id,
            name: userInfo.firstName + ' ' + userInfo.lastName
          }
          return this.verifyHoldShipment(userInfo.id);
        }
        else {
          this.Modal.confirmSupervisor('verify-shipments', null, ({ modal, supId }) => {
            modal.close();
            return this.verifyHoldShipment(supId)
          }, ({ modal }) => {
            modal.close();
            this.isLoading = false;
          });
        }
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
  }

  verifyHoldShipment(supId) {
    this.Modal.verifyHoldShipments(this.model.lastChecked, this.setupInfo.allowBulkHoldVerify ,({ modal, $scope, Verifycomments }) => {
      const defer = this.$q.defer();
      $scope.loading = true;
      this.holdTrackingId = $scope.model.verifiedShipments.map((data => data.trackingId))

        this.HoldService.verifyHoldshipment(this.User.getUser().branchId, this.holdTrackingId, Verifycomments, supId, this.currentVaultDate, $scope.model.bulkVerified)
        .then((data) => {
          modal.close();
          defer.resolve(data);
          return this.ShipmentService.updateShipmentTankerId(this.holdTrackingId, $scope.model.tankerId, this.model.branch); //  update tanker for shipemnt
        })
        .catch((err) => {
          modal.close();
          if (err && err.data && err.data.message) {
            defer.reject(err);
            this.Modal.errorModal('error.' + err.data.message)
          }
        })
      defer.promise
        .then(() => {
          this.loadData();
          this.isLoading = false;
        })
    }, ({ modal }) => {
      modal.close();
      this.isLoading = false;
    });
  }

  // show log of verify data by trackingId   
  showLogById(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.Modal.itemHoldLogDetails(shipment.trackingId, shipment.holdverifies[0].holdId, false, ({ modal }) => {
      if (modal) modal.close();
      this.isLoading = false
    }, ({ modal }) => {
      if (modal) modal.close();
      this.isLoading = false;
    })
  }

  convertToCrv(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.convertToCrv(shipment, !userInfo.supervisor, true, ({ supervisor, trackingIdResidual, modal }) => {
          if (trackingIdResidual) {
            const defer = this.$q.defer();
            this.HoldService.convertToCRV(this.model.branch, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor)
              .then((data) => {
                modal.close();
                const totals = this.DataCounter.getCounterForItemHold();
                this.DataCounter.setCounterForItemHold(totals - 1);
                defer.resolve(data);
              })
              .catch((err) => {
                modal.close();
                if (err && err.data && err.data.message) {
                  this.isLoading = false;
                  this.Modal.errorModal('error.' + err.data.message)
                }
              })
            defer.promise
              .then(() => {
                this.isLoading = false;
                this.loadData();
              })
          }
          else {
            if (modal) modal.close();
            this.isLoading = false;
          }
        }, ({ modal }) => {
          if (modal) modal.close();
          this.isLoading = false;
        })
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
  }


  convertToCrvPackableOrder(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.Modal.confirm({
      header: 'Confirm CRV Conversion', 
      message: 'Are you sure you want to convert this Shipment to CRV?', 
      callback: ({ modal, $scope }) => {
        modal.close();
        this.UsersService.checkSupervisor(this.loggedInUser)
          .then((userInfo) => {
            this.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, ({ modal: supModal, supId }) => {
              supModal.close();
              const defer = this.$q.defer();
              this.HoldService.convertToCrvPackableOrder(this.model.branch, shipment.trackingId, shipment.packableOrderShipmentId, supId)
                .then((data) => {
                  const totals = this.DataCounter.getCounterForItemHold();
                  this.DataCounter.setCounterForItemHold(totals - 1);
                  defer.resolve(data);
                })
                .catch((err) => {
                  if (err && err.data && err.data.message) {
                    this.isLoading = false;
                    this.Modal.errorModal('error.' + err.data.message);
                  }
                });
  
              defer.promise
                .then(() => {
                  this.isLoading = false;
                  this.loadData();
                });
            }, ({ modal: supModal }) => {
              supModal.close();
              this.isLoading = false;
            });
          })
          .catch((err) => {
            this.Modal.errorModal(err.data.message);
            this.isLoading = false;
          });
      },
      negative: ({ modal, $scope }) => {
        modal.close();
        this.isLoading = false;
      }
    });
  }
  
  
  // soft delete shipment (it will update shipment.deleted flag true, and hold.status = 'DELETED')
  // note : if user delete loadShipments it will also delete residualShipments   
  removeShipment(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.shipmentId = shipment.shipmentId || null;
    this.Modal.deletedReason(shipment, ({ supervisorId, reason, modal }) => {
      this.HoldService.softDeleteShipment(shipment.trackingId, supervisorId, reason, this.shipmentId, shipment.branchId)
        .then(() => {
          modal.close();
          const totals = this.DataCounter.getCounterForItemHold();
          this.DataCounter.setCounterForItemHold(totals - 1);
        })
        .then(() => {
          setTimeout(() => {
            this.loadData();
            this.isLoading = false;
          }, 500)
        })
        .catch((err) => {
          modal.close();
          this.isLoading = false;
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal('error.' + err.data.message)
          }
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.isLoading = false;
    });
  }

  sortData(column) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column
    this.loadData();
  }

  //   getOrderType(type) {
  //     switch (type) {
  //         case type: return this.$translate.instant('shipment.order_type_' + type);
  //         default: return '';
  //     }
  // }

  goToItemHistory(trackingId) {
    this.$state.go('branchManagement.items', {
      id: trackingId,
    });
  }

  markAsDelivered(shipment) {
    this.Modal.markAsDelivered(shipment, this.branchVaultDate, this.branchTimeZone, ({ modal, supervisorId, comment, loadedAmount, date, time, sendDeliveryReceipt }) => {
      this.HoldService.shipmentDelivery(shipment.trackingId, shipment.route.id, supervisorId, comment, shipment.branchId, 
                                        loadedAmount, date, time, this.branchTimeZone, shipment.orderType, shipment.amount, sendDeliveryReceipt)
        .then(() => {
          modal.close();
          const totals = this.DataCounter.getCounterForItemHold();
          this.DataCounter.setCounterForItemHold(totals - 1);
          this.loadData(); // refresh data after shipment delivered  
        })
        .catch((err) => {
          modal.close();
          this.Modal.errorModal('error.' + err.data.message)
        })
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  redirectToOrderTab(data) {
    const obj = {
      orderNo: data.orderNo,
      vaultDate: data.holdDate,
      isRedirected: true,
      isCounted: false,
      isInProcess: true,
      fundingSourceId: data.fundingSourceId
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.orders');
  }

  removeLeadingZero(orderNo) {
    if (orderNo) return orderNo.replace(/^0+/, '');
  }
  

  exportData() {
    const searchObj = this.generateSearchObj();
    searchObj.currentVaultDate = this.currentVaultDate;

    this.isExporting = true;
    this.HoldService.exportItemHoldData(searchObj, 0, 10000)
      .then((data) => {
        this.fileName = this.reportPrefix.concat('_', this.currentVaultDate, '.csv');
        let a = document.createElement("a");
        document.body.appendChild(a);
        let file = new Blob([data.reportData], { type: 'application/csv' });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = this.fileName;
        a.click();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.isExporting = false;
      })
  }

  filterRecords() {
    if (this.shipmentData && this.shipmentData.isRedirected) {
      this.model.search = this.shipmentData.trackingId;
      this.loadData()
        .then(() => {
          this.resetFilters();
        })
    }
  }

  resetFilters() {
    if (this.shipmentData) {
      this.shipmentData.isRedirected = false;
      this.shipmentData = this.DataCounter.setData();
    }
  }

  orderPackingUndo(shipment) {
    if (this.loading) return;
    this.loading = true;

    this.Modal.undoPackedOrder(shipment, ({ modal, supervisorId, deleteOrder, deletedReason, $scope }) => {
      this.ShipmentService.orderPackingUndo(shipment.branchId, shipment.shipmentId, supervisorId, deletedReason, deleteOrder)
        .then(() => {
          modal.close();
          this.loading = false;
          const totals = this.DataCounter.getCounterForItemHold();
          this.DataCounter.setCounterForItemHold(totals - 1);
          this.loadData();
        })
        .catch((err) => {
          modal.close();
          if (err && err.data && err.data.message) {
            this.loading = false;
            this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.loading = false;
    })
  }

  goToServiceHistory(locationId) {
    return this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  isAllowedToUnpack(shipment) {
    let shipmentPackedDate, branchCurrentVaultDate;
    
    if (shipment.fundingSourceId && shipment.unpackAnyTime) {
      return true;
    }
    else if (shipment.fundingSourceId && !shipment.unpackAnyTime) {
      shipmentPackedDate = new Date(shipment.packedDate);
      branchCurrentVaultDate = new Date(this.branchVaultDate);
      return shipmentPackedDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
    }
    else {
      return true;
    }
  }

  markAsCheckedIn(shipment) {
    this.Modal.confirmSupervisor('mark-as-checked-in', shipment.trackingId, ({ modal, supId }) => {
      this.HoldService.shipmentHoldMarkCheckedIn(shipment.trackingId, supId, shipment.branchId, shipment.routeId)
        .then(() => {
          modal.close();
          const totals = this.DataCounter.getCounterForItemHold();
          this.DataCounter.setCounterForItemHold(totals - 1);
          this.loadData();
        })
        .catch((err) => {
          modal.close();
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
       modal.close();
    })
  }

  softDeleteBagouts() {
    const reason = 'Auto Soft Delete Bagouts Enabled';

    this.isSoftDeleting = true;
    this.Modal.bagoutsOnHoldModal(({ modal, supervisorId }) => {
      this.HoldService.softDeleteBagoutsOnHold(this.model.branch, supervisorId, reason)
        .then(() => {
          this.loadData();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          modal.close();
          this.isSoftDeleting = false;
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.isSoftDeleting = false;
    })
  }

  formatAddress(data) {
    let locationAddress = '';
    if (!data || !data.toLocation) return;

    if (data.toLocation.address) {
      locationAddress = locationAddress.concat(data.toLocation.address, ', ');
    }
    if (data.toLocation.city) {
      locationAddress = locationAddress.concat(data.toLocation.city, ', ');
    }
    if (data.toLocation.state) {
      locationAddress = locationAddress.concat(data.toLocation.state, ', ');
    }
    if (data.toLocation.zip) {
      locationAddress = locationAddress.concat(data.toLocation.zip, '.');
    }
    return locationAddress;
  }

  isNullorEmptyString(comment) {
    return comment == null || comment.trim() === '';
  }

  releasePickupShipment(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.pickupHoldRelease(shipment, !userInfo.supervisor, ({ supervisorId, comment, shipmentAssignedTo, selectedDate, routeInfo, locationId, modal }) => {
          var hDate = moment(selectedDate).utc(true).format('YYYY-MM-DD');
          this.HoldService.pickupHoldRelease(shipment.trackingId, shipment.routeId, shipmentAssignedTo, hDate, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId, locationId)
            .then(() => {
              modal.close();
              const totals = this.DataCounter.getCounterForItemHold();
              this.DataCounter.setCounterForItemHold(totals - 1);
              this.Sound.playSuccessBeep("#success_beep");
            })
            .then(() => {
              if (routeInfo.routeTransfered) {
                this.updateRouteDetail(shipmentAssignedTo, selectedDate);
              }
            })
            .then(() => {
              this.loadData();
              this.isLoading = false;
            })
            .catch((err) => {
              modal.close();
              this.isLoading = false;
              this.Sound.PlayErrorBeep("#scanner_beep");
              if (err && err.data && err.data.message) {
                return this.Modal.errorModal("error." + err.data.message);
              }
            })
        }, ({ modal }) => {
          this.isLoading = false;
          if (modal) modal.close();
        });
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
  }

  convertShipmentHoldToPickup(shipment) {
    this.Modal.confirmSupervisor('convert-shipment-hold-to-pickup', shipment.trackingId, ({ modal, supId }) => {
      this.HoldService.convertShipmentHoldToPickup(shipment.trackingId, shipment.routeId, supId, shipment.branchId, shipment.fromLocationId, shipment.toLocationId)
        .then(() => {
          modal.close();
          const totals = this.DataCounter.getCounterForItemHold();
          this.DataCounter.setCounterForItemHold(totals - 1);
          this.loadData();
        })
        .catch((err) => {
          modal.close();
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
      modal.close();
    })
  }

  canReleaseForCount(shipment) {
    return !!(shipment && shipment.onHold && shipment.canReleaseForCount === 1);
  }

  releaseForCount(shipment) {
    if (this.isLoading) return;
    this.isLoading = true;

    this.Modal.confirmSupervisor('release-for-count', shipment.trackingId, ({ modal, supId }) => {
      const defaultComment = 'Released for count';
      this.HoldService.releaseForCount(shipment.trackingId, shipment.routeId, supId, defaultComment)
        .then(() => {
          modal.close();
          const totals = this.DataCounter.getCounterForItemHold();
          this.DataCounter.setCounterForItemHold(Math.max(0, totals - 1));
        })
        .then(() => {
          this.loadData();
          this.isLoading = false;
        })
        .catch((err) => {
          modal.close();
          this.isLoading = false;
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal('error.' + err.data.message);
          }
        });
    }, ({ modal }) => {
      if (modal) modal.close();
      this.isLoading = false;
    });
  }
  getOrderType(shiptype, orderType) {
    if (shiptype == "C" && orderType !== null) {
      return this.$translate.instant('atm_residual.order_type_' + orderType);
    }
    else if (shiptype == "C" && orderType == null) {
      return shiptype.toUpperCase();
    }
    else {
      return shiptype.toUpperCase();
    }
  }

  getSoftDeleteShipmentPermission() {
    this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName)
      .then((permissions) => {
        this.hasSoftDeleteShipmentPermission = (permissions.hasSoftDeleteShipmentPermission || this.CommonLayoutService.isAllowToAccessPages());
      })
      .catch((err) => {
        console.log(err);
      });
  };

  validateMapView() {
    this.isValidMapView = !!(
      this.showMapView &&
      !this.model.loading &&
      Array.isArray(this.shipments) &&
      this.shipments.some(s => s.toLocation && s.toLocation.lat && s.toLocation.long)
    );
    return this.isValidMapView;
  }

  get canShowMap() {
    return this.isValidMapView;
  }

  toggleMapView() {
    this.validateMapView();
    if (!this.showMapView && this.map) {
      this.map.remove();
      this.map = null;
    } else if (this.showMapView && !this.map && this.isValidMapView) {
      setTimeout(() => {
        this.initHoldMap();
      }, 200);
    }
  }

  initHoldMap() {
    try {
      if (!document.getElementById('hold-map')) {
        console.error('Map container not found');
        return;
      }

      if (this.map) {
        this.map.remove();
      }

      // Get branch location
      const branchLat = (this.setupInfo && this.setupInfo.gpsLat) ? this.setupInfo.gpsLat : 39.6864921;
      const branchLng = (this.setupInfo && this.setupInfo.gpsLong) ? this.setupInfo.gpsLong : -101.4827398;

      this.map = L.map('hold-map', {});

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);

      // Branch marker with complete info
      const branchInfo = `<strong>${this.setupInfo.branchId}</strong><br>${this.setupInfo.address} - ${this.setupInfo.zip}<br>${this.setupInfo.city}, ${this.setupInfo.state}`;
      
      const branchMarker = L.marker([branchLat, branchLng], {
        icon: new L.AwesomeNumberMarkers({
          number: 'B',
          markerColor: 'black'
        })
      })
      .addTo(this.map)
      .bindPopup(branchInfo);

      branchMarker.on('mouseover', function() {
        this.openPopup();
      });

      branchMarker.on('mouseout', function() {
        this.closePopup();
      });

      // Hold locations
      if (this.shipments) {
        this.shipments.forEach((shipment, index) => {
          if (shipment.toLocation && shipment.toLocation.lat && shipment.toLocation.long) {
            const locationInfo = `<strong>${shipment.toLocation.name}</strong> | <span>${shipment.trackingId}</span><br>${shipment.toLocation.address} - ${shipment.toLocation.zip}<br>${shipment.toLocation.city}, ${shipment.toLocation.state}`;
            const marker = L.marker([shipment.toLocation.lat, shipment.toLocation.long], {
              icon: new L.AwesomeNumberMarkers({
                number: index + 1,
                markerColor: 'blue'
              })
            })
            .addTo(this.map)
            .bindPopup(locationInfo);

            marker.on('mouseover', function() {
              this.openPopup();
            });

            marker.on('mouseout', function() {
              this.closePopup();
            });
          }
        });
      }

      const bounds = this.shipments
        .filter(s => s.toLocation && s.toLocation.lat && s.toLocation.long)
        .map(s => [s.toLocation.lat, s.toLocation.long]);
      bounds.push([branchLat, branchLng]);
      
      if (bounds.length) {
        this.map.fitBounds(bounds);
      } else {
        this.map.setView([branchLat, branchLng], 7);
      }
      
      setTimeout(() => {
        this.map.invalidateSize();
      }, 100);

    } catch (error) {
      console.error('Error initializing map:', error);
    }
  }
}

export default ItemHoldsController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/item_holds/item_holds.controller.js